import React, {forwardRef, Fragment, useEffect, useState} from "react" ;
import {getDataFromResponse, Globals} from "root/DataFunctions/BaseDataFns";
import {getUserOrganisationDetails} from "root/DataFunctions/UserDataFns";
import {useGlobalContext} from "root/contexts/GlobalContext";

const WieldyPageHeader= forwardRef((props, ref) =>
{
    const [data, setData] = useState({ isLoading: true, data: [] });

    const { user_org } = useGlobalContext() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>{
        getUserOrganisationDetails( user_org, (response) =>
        {
            let orgData = getDataFromResponse(response)[0] ;
            setData({ isLoading: false, data: orgData});
        });
    }

    const titleStyle = {
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        height: '100%'
    }

    return (
        <Fragment>
            <header ref={ref} className="dt-header">

                {/* Header container */}
                <div className="dt-header__container">

                    {/* Brand */}
                    <div className="dt-brand">

                        { props.brandTool() }

                        {/* Brand logo */}
                        <span className="dt-brand__logo">
                                <a className="dt-brand__logo-link" href="/arcom/home">
                                  <img className="dt-brand__logo-img d-none d-lg-inline-block"
                                       src="/images/logos/arclogo.png"
                                       alt="Wieldy"/>
                                  <img className="dt-brand__logo-symbol d-lg-none"
                                       src="https://via.placeholder.com/35x18" alt="Wieldy"/>
                                </a>
                          </span>
                    </div>

                    {/* Header toolbar*/}
                    <div className="dt-header__toolbar">
                        <div className='form-control border-0' style={titleStyle}>
                            <h2>{data.data.name}</h2>
                        </div>
                        {/* Search box
                        <form className="search-box d-none d-lg-block">
                            <input className="form-control border-0" placeholder="Search in app..." value="" type="search"/>
                            <span className="search-icon text-light-gray"><i className="icon icon-search icon-lg"/></span>
                        </form>*/}

                    </div>

                </div>

            </header>
        </Fragment>
    ) ;
});

export default WieldyPageHeader;
